export default __webpack_public_path__ + "static/media/personal.bab34e15.png";